/**
 * Поддерживаемые локали survey-client (как в passport-client).
 *
 * @module constants/locale
 */

export const LOCALE = {
  ru: 'ru',
  en: 'en',
  de: 'de',
  es: 'es',
  pl: 'pl',
  pt: 'pt',
  cs: 'cs',
  uk: 'uk',
} as const;

export type TLocalesKeys = keyof typeof LOCALE;
export type TLocalesValues = (typeof LOCALE)[TLocalesKeys];

export const LOCALE_DEFAULT: TLocalesValues = LOCALE.en;
export const LOCALE_SUPPORTED: TLocalesValues[] = Object.values(LOCALE);

/**
 * Проверяет, входит ли строка в список поддерживаемых локалей.
 *
 * @param {string} locale — сырое значение
 * @returns {boolean}
 */
function checkLocale(locale: string): boolean {
  return LOCALE_SUPPORTED.includes(locale as TLocalesValues);
}

/**
 * Нормализует языковой тег к одной из поддерживаемых локалей.
 *
 * @param {string | undefined | null} key — язык из URL, storage или navigator
 * @returns {TLocalesValues}
 */
export function localeNormalize(key: string | undefined | null): TLocalesValues {
  if (key === undefined || key === null || key === '') {
    return LOCALE_DEFAULT;
  }

  let locale = key;
  if (checkLocale(locale)) {
    return locale as TLocalesValues;
  }
  locale = key.toLowerCase();
  if (locale === 'pt' || locale === 'pt-br') {
    return LOCALE.pt;
  }
  if (checkLocale(locale)) {
    return locale as TLocalesValues;
  }

  return LOCALE_DEFAULT;
}
